import { useDispatch, useSelector } from "react-redux"
import Popup from "../../components/Popup"
import { closeUpdatingSavedReceiverPopup, openUpdatingSavedReceiverPopup, selectSavedReceivers, selectSavedReceiversErrors, selectSavedReceiversStatuses, selectUpdatingSavedReceiverPopup, setSavedReceiversUpdatingError, setSavedReceiversUpdatingStatus, updateSavedReceiver } from "./savedReceiversSlice"

import style from "../../sass/components/popups/create-shipment-popup.module.scss"
import PhoneInput from "react-phone-input-2"
import SelectCity, { selectCityInputLanguages } from "../citySelect/SelectCity"
import { useEffect, useState } from "react"
import { validators } from "../../validators/validators"
import { interpretReceiverAddressError } from "../../validators/interpretators"
import { Button } from "@mui/material"
import { pushAlert } from "../alerts/alertSlice"
import { validateReceiver } from "../../validators/validateReceiver"
import { useTranslation } from "react-i18next"

const initialErrors = {
    name: "",
    company: "",
    email: "",
    "phone-number": "",
    "address": "",
    "postal-index": "",
}

const EditSavedReceiverPopup = () => {
    const {t, i18n} = useTranslation()
    const dispatch = useDispatch()
    const popupState = useSelector(selectUpdatingSavedReceiverPopup)
    const receivers = useSelector(selectSavedReceivers)
    const receiversStatuses = useSelector(selectSavedReceiversStatuses)
    const receiversErrors = useSelector(selectSavedReceiversErrors)

    const [state, setState] = useState({
        name: "",
        company: "",
        email: "",
        "phone-number": "",
        "address": "",
        "postal-index": "",
        "countryHasCities": false,
    })
    
    const [errors, setErrors] = useState({
        name: "",
        company: "",
        email: "",
        "phone-number": "",
        "address": "",
        "postal-index": "",
    })

    const [receiverGeolocation, setReceiverGeolocation] = useState({
        country: "Россия",
        city: "",
        area: "",
        district: "",
    })

    const setName = (value) => {
        setState((prev) => ({ ...prev, "name": value }));

        let validationResult = 
            validators.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value) || 
            validators.HasOnlyLettersAndSpaces(value)
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "name": t("saved_receivers.errors.name.only_english_letters_and_spaces"),
            }));

            return
        }

        setErrors((prev) => ({
            ...prev,
            "name": "",
        }));
    };

    const setReceiverCompany = (value) => {
        setState((prev) => ({ ...prev, "company": value }));

        if(value.length > 250) {
            setErrors((prev) => ({
                ...prev,
                "company": t("saved_receivers.company.max_250"),
            }));
        }
    };

    const setAddress = (value) => {
        setState((prev) => ({ ...prev, "address": value }));

        let validationResult = interpretReceiverAddressError(
            validators.ValidateReceiverAddress(value)
        );
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "address": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "address": "",
            }));
        }
    };

    const setPostalIndex = (value) => {
        setState((prev) => ({ ...prev, "postal-index": value }));
    }

    const setPhoneNumber = (value) => {
        setState((prev) => ({ ...prev, "phone-number": value }));

        let validationResult = validators.ValidatePhone(value, 7);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "phone-number": t("saved_receivers.errors.phone.invalid_format"),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "phone-number": "",
            }));
        }
    };

    const setEmail = (value) => {
        setState((prev) => ({ ...prev, "email": value }));

        let validationResult = validators.ValidateEmail(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "email": t("saved_receivers.errors.email.invalid_format"),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "email": "",
            }));
        }
    };

    const closePopup = () => {
        dispatch(closeUpdatingSavedReceiverPopup())
    }

    useEffect(() => {
        if(popupState.savedReceiverID) { 
            let receiver = receivers.find(receiver => receiver.id === popupState.savedReceiverID)
            
            if(!receiver) return

            setState({
                name: receiver.name,
                company: receiver.company,
                email: receiver.email,
                "phone-number": receiver["phone-number"],
                "address": receiver.address,
                "postal-index": receiver["postal-index"],
                "countryHasCities": receiver.countryHasCities,
            })
            setReceiverGeolocation({
                country: receiver?.geolocation?.country,
                city: receiver?.geolocation?.city,
                area: receiver?.geolocation?.area,
                district: receiver?.geolocation?.district,
            })
        }
    }, [popupState.savedReceiverID, receivers])

    useEffect(() => {
        if(receiversStatuses.updating === "fulfilled") {
            dispatch(pushAlert({
                message: t("saved_receivers.successfully_updated"),
                type: "success",
                delay: 2000,
            }))

            dispatch(closeUpdatingSavedReceiverPopup())
            dispatch(setSavedReceiversUpdatingStatus(null))
            return
        }
    }, [dispatch, receiversStatuses])

    useEffect(() => {
        if(receiversErrors.updating != null) {
            dispatch(pushAlert({
                message: t(receiversErrors.updating),
                type: "danger",
                delay: 2000,
            }))

            dispatch(setSavedReceiversUpdatingError(null))
        }
    }, [dispatch, receiversErrors.updating])

    const handleButtonClick = () => {

        let dataForValidation = {
            "receiver-name": state.name,
            "receiver-company": state.company,
            "receiver-email": state.email,
            "receiver-phone-number": state["phone-number"],
            "receiver-address": state.address,
            "receiver-postal-index": state["postal-index"],
        }
        let validationResult = validateReceiver(dataForValidation)
        
        if(validationResult.length > 0) {
            validationResult.forEach(error => {
                dispatch(pushAlert({
                    message: error,
                    type: "danger",
                    delay: 2000,
                }))
            })
            return
        }
        dispatch(updateSavedReceiver({
            id: popupState.savedReceiverID,
            name: state.name,
            company: state.company,
            email: state.email,
            "phone-number": state["phone-number"],
            address: state.address,
            "postal-index": state["postal-index"],
            country: receiverGeolocation.country,
            city: receiverGeolocation.city,
            area: receiverGeolocation.area,
            district: receiverGeolocation.district,
        }))
    }

    return (
    <Popup opened={popupState.opened} closeCallback={closePopup}>
        <header className="text-xl text-emerald-600 text-left mb-3">
            {t("saved_receivers.edit_popup.title")}
        </header>
        <main className="text-left flex flex-col gap-4">
                <div>
                    <input
                        className={`${style.input} ${style.standard}`}
                        type="text"
                        placeholder={t("saved_receivers.edit_popup.name.placeholder")}
                        onChange={(e) => setName(e.target.value)}
                        value={state["name"]}
                    />
                    {errors["name"] && (
                        <div className={style.error}>
                            {errors["name"]}
                        </div>
                    )}
                </div>
                <div>
                    <input
                        className={`${style.input} ${style.standard}`}
                        type="text"
                        placeholder={t("saved_receivers.edit_popup.company.placeholder") + " " + t("global.optional")}
                        onChange={(e) => setReceiverCompany(e.target.value)}
                        value={state["company"]}
                    />
                    {errors["company"] && (
                        <div className={style.error}>
                            {errors["company"]}
                        </div>
                    )}
                </div>
                <div>
                    <input
                        className={`${style.input} ${style.standard}`}
                        type="text"
                        placeholder={t("saved_receivers.edit_popup.email.placeholder")}
                        onChange={(e) => setEmail(e.target.value)}
                        value={state["email"]}
                    />
                    {errors["email"] && (
                        <div className={style.error}>
                            {errors["email"]}
                        </div>
                    )}
                </div>
                <div className="grid grid-cols-12">
                    <span 
                        className="col-span-12 text-gray-600"
                    >
                        {t("saved_receivers.edit_popup.phone.title")}
                    </span>
                    <PhoneInput 
                        value={state["phone-number"]}
                        onChange={(e) => setPhoneNumber(e)}
                        country={"ru"}
                        inputClass={`${style.input} ${style.standard}`}
                        specialLabel=""
                        dropdownClass="hidden"
                        dropdownStyle={{display: "none"}}
                        className="col-span-12"
                    />
                </div>
                <div>
                    <SelectCity
                        state={receiverGeolocation}
                        setState={setReceiverGeolocation}
                        selectClassName={`${style.select} col-span-8 text-xs`}
                        containerClassName={"flex flex-col max-w-sm"}
                        labelClassNames={"col-span-2 text-gray-600"}
                        inputsClassNames={`${style.input} col-span-8 text-xs`}
                        inputBlockClassNames={
                            "grid items-center grid-cols-10 mb-2"
                        }
                        language={selectCityInputLanguages.TR}
                    />
                    {!receiverGeolocation.city && state.countryHasCities && (
                        <div className={style.error}>
                            {t("saved_receivers.errors.city.required")}
                        </div>
                    )}
                </div>
                <div>
                    <input
                        className={`${style.input} ${style.standard}`}
                        type="text"
                        placeholder={t("saved_receivers.edit_popup.address.placeholder")}
                        onChange={(e) => setAddress(e.target.value)}
                        value={state["address"]}
                    />
                    {errors["address"] && (
                        <div className={style.error}>
                            {errors["address"]}
                        </div>
                    )}
                </div>
                <div>
                    <input
                        className={`${style.input} ${style.standard}`}
                        type="text"
                        placeholder={t("saved_receivers.edit_popup.postal_index.placeholder")}
                        onChange={(e) => setPostalIndex(e.target.value)}
                        value={state["postal-index"]}
                    />
                </div>

                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                        ":focus": {
                            bgcolor: "#047857",
                        },
                    }}
                    className="w-10/12"
                    onClick={handleButtonClick}
                >
                    {t("saved_receivers.edit_popup.save_button")}
                </Button>
                
            </main>
    </Popup>
  )
}

export default EditSavedReceiverPopup